import { useState, useEffect, useCallback } from 'react'
import { PendingRequestsBadge } from '../PendingRequestsBadge'
import { ReviewStudentRequestsModal } from './ReviewStudentRequestsModal'
import { useStudentRequests } from './useStudentRequests'

export function StudentRequestsWidget() {
  const [modalOpened, setModalOpened] = useState(false)
  const hook = useStudentRequests()
  const { refreshCount, fetchData, sessionExpired } = hook

  // Refresh count on mount and poll every 10 seconds. When the hook flags an
  // idle session expiry (silent 401) the effect re-runs and clears the
  // interval for good — no toast, no redirect without user action.
  useEffect(() => {
    if (sessionExpired) return

    refreshCount()

    const interval = setInterval(() => {
      refreshCount()
    }, 10_000)

    return () => clearInterval(interval)
  }, [refreshCount, sessionExpired])

  // Fetch full data when drawer opens
  useEffect(() => {
    if (modalOpened) {
      fetchData()
    }
  }, [modalOpened, fetchData])

  const handleClose = useCallback(() => {
    setModalOpened(false)
    refreshCount()
  }, [refreshCount])

  const handleOpen = useCallback(() => {
    setModalOpened(true)
  }, [])

  return (
    <>
      <PendingRequestsBadge count={hook.pendingCount} onClick={handleOpen} />
      <ReviewStudentRequestsModal opened={modalOpened} onClose={handleClose} hook={hook} />
    </>
  )
}
